module.exports = __webpack_public_path__ + "static/img/supplier-01-big.2104e52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/supplier-01-big.jpg
// module id = FeCl
// module chunks = 2